import XLSX from 'xlsx'

/**
 * 导出 Excel 文件
 * @param {Array} list 数据列表
 * @param {Array} headers 表头（如 ['手机号']）
 * @param {string} filename 文件名（含 .xlsx 后缀）
 * @param {Function} showMessage 提示函数（用于提示无数据等）
 */
export const exportExcel = (
  list,
  headers = ['手机号'],
  valFn = (item) => {
    return [item.LoginName]
  },
  filename = '导出数据.xlsx',
  showMessage = console.warn
) => {
  if (!Array.isArray(list)) {
    showMessage('数据格式不正确', 'error')
    return
  }

  if (list.length === 0) {
    showMessage('暂无数据', 'warning')
    return
  }

  const exportList = [headers]
  list.forEach((item, i) => {
    exportList.push(valFn(item, i))
  })

  const sheet = XLSX.utils.aoa_to_sheet(exportList)
  const blob = sheet2blob(sheet)
  openDownloadDialog(blob, filename)
}

/**
 * 将 sheet 转换为 Blob
 * @param {Object} sheet Sheet 对象
 * @returns {Blob}
 */
const sheet2blob = (sheet) => {
  const workbook = {
    SheetNames: ['sheet1'],
    Sheets: { sheet1: sheet }
  }

  const work = {
    bookType: 'xlsx',
    bookSST: false,
    type: 'binary'
  }

  const xlsx = XLSX.write(workbook, work)
  const blob = new Blob([s2ab(xlsx)], { type: 'application/octet-stream' })
  return blob
}

/**
 * 字符串转 ArrayBuffer
 * @param {string} s 字符串
 * @returns {ArrayBuffer}
 */
const s2ab = (s) => {
  const buf = new ArrayBuffer(s.length)
  const view = new Uint8Array(buf)
  for (let i = 0; i !== s.length; ++i) {
    view[i] = s.charCodeAt(i) & 0xff
  }
  return buf
}

/**
 * 触发浏览器下载文件
 * @param {Blob} blob 文件内容
 * @param {string} saveName 下载的文件名
 */
const openDownloadDialog = (blob, saveName) => {
  const url = URL.createObjectURL(blob)
  const aLink = document.createElement('a')
  aLink.href = url
  aLink.download = saveName
  aLink.click()
  URL.revokeObjectURL(url) // 释放内存
}
